/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_True_Samuel_BendInputs */

const fr_wide_true_samuel_bend = /** @type {(inputs: Wide_True_Samuel_BendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/**

* @param {Wide_True_Samuel_BendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wide_true_samuel_bend = /** @type {((inputs?: Wide_True_Samuel_BendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_True_Samuel_BendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wide_true_samuel_bend(inputs)
});